module.exports = __webpack_public_path__ + "img/ico_view_arrow_left.cd62c7af.svg";